import { environment } from '@environments/environment';
import { baseUri } from '@shared/user/constants/uri.constants';

export const endpointUri = `${environment.apiUri}/${baseUri}`;
